import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import autosize from 'autosize';
import { useEffect, useRef } from 'react';
import { propBool, propNumber, propShape, propStr, } from '../../../helpers/custom-prop-types';
import InputError from './InputError';
const PlainTextAreaComponent = (props) => {
    const { autosized, className, disabled, input, maxLength, meta, placeholder, readOnly, rows, showError, } = props;
    const ref = useRef(null);
    useEffect(() => {
        let dom = null;
        if (autosized && ref.current) {
            dom = autosize(ref.current);
        }
        return () => {
            if (dom) {
                autosize.destroy(dom);
            }
        };
    }, [autosized, ref]);
    return (_jsxs(_Fragment, { children: [_jsx("textarea", Object.assign({}, input, { className: `${className} ${meta.touched && meta.error ? 'is-warning' : ''}`, disabled: disabled, maxLength: maxLength, placeholder: placeholder, readOnly: readOnly, ref: ref, rows: rows })), showError && _jsx(InputError, { meta: meta })] }));
};
PlainTextAreaComponent.propTypes = {
    autosized: propBool(),
    className: propStr().isRequired,
    disabled: propBool(),
    input: propShape().isRequired,
    maxLength: propNumber(),
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
    readOnly: propBool(),
    rows: propNumber(),
    showError: propBool(),
};
PlainTextAreaComponent.defaultProps = {
    autosized: false,
    disabled: false,
    maxLength: null,
    readOnly: false,
    rows: undefined,
    showError: true,
};
export default PlainTextAreaComponent;
